export default () => {
  // If cookies are disabled
  if (navigator && !navigator.cookieEnabled) {
    return {
      cookieDisabled: true,
      localStorage: {
        setItem: () => undefined,
        getItem: () => undefined
      }
    };
  }

  // In JSDom env, e.g. jest/unit tests
  if (!window || !window.localStorage) {
    return {
      localStorage: require("mock-local-storage")
    };
  }

  return window;
};
